import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import * as crypto from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EpayService {

  constructor(private http: HttpClient) { }

  generateChecksum(encoded: string): string {
    return crypto.HmacSHA1(encoded, environment.easyPaySecret).toString();
  }

  requestPayment(encoded: string, checksum: string): Observable<any> {
    const params = new HttpParams()
      .set('ENCODED', encoded)
      .set('CHECKSUM', checksum);

    return this.http.get(`${environment.epayUrl}ezp/ezp/reg_bill.cgi`, { params, responseType: 'text' }).pipe(
      map(response => {
        try {
          return JSON.parse(response); // Опитай да парснеш отговора като JSON
        } catch (e) {
          return response; // Върни отговора като текст, ако JSON парсването се провали
        }
      })
    );
  }



  encodeData(data: any): string {
    let dataString = Object.keys(data).map(key => `${key}=${data[key]}`).join('\n');
    return btoa(dataString); // Base64 encoding
  }

  simulatePayment(idn: string): Observable<any> {
    const params = new HttpParams()
      .set('ACTION', 'PAY')
      .set('IDN', idn);

    return this.http.get(`${environment.epayUrl}ezp/pay_bill.cgi`, { params });
  }

  generateEPayProfilePaymentUrl(data: any, page: string, lang: string, urlOk: string, urlCancel: string): string {
    const encoded = this.encodeData(data);
    const checksum = this.generateChecksum(encoded);

    const url = new URL(environment.epayUrl);
    url.searchParams.append('PAGE', page);
    url.searchParams.append('ENCODED', encoded);
    url.searchParams.append('CHECKSUM', checksum);
    url.searchParams.append('LANG', lang);
    url.searchParams.append('URL_OK', urlOk);
    url.searchParams.append('URL_CANCEL', urlCancel);

    return url.toString();
  }
}
